import { EventDescription, NoEventCardContainer } from "./event-card-styles";

type NoEventCardProps = {
  message: string;
};

export function NoEventCard(props: NoEventCardProps) {
  return (
    <NoEventCardContainer>
      <div className="mb-4 flex items-center justify-center">
        <EventDescription title={props.message}>
          {props.message}
        </EventDescription>
      </div>
    </NoEventCardContainer>
  );
}
